@if (isDigital() || isBoosted() || isAbroad()) {
  <div class="label-section flex flex-row 2xl:flex-col 3xl:flex-row gap-2 justify-end w-fit">
    @if (isDigital() && !isAbroad()) {
      <div
        class="digital-badge    rounded-2xl bg-blueberry-10 py-1.5 px-3 text-sm text-blueberry-3 inline-block text-center font-medium w-fit grow-0 basis-0 self-auto">
        Digital&nbsp;vårdgivare
      </div>
    }

    @if (isAbroad()) {
      <div
        class="abroad-badge rounded-2xl bg-apricot-6 py-1.5 px-3 text-sm text-apricot-1 inline-block text-center font-medium w-fit grow-0 basis-0 self-auto whitespace-nowrap"
      >
        Vårdgivare utomlands
      </div>
    }

    @if (isBoosted()) {
      <div
        #tooltip="matTooltip"
        class="boosted-badge   rounded-2xl bg-duck-blue-9 py-1.5 px-3 text-sm text-duck-blue-1 inline-block text-center font-medium w-fit grow-0 basis-0 self-auto"
        matTooltip="Den här vårdgivaren är utvald av Vården.se och kan ha betalat lite extra för sin exponering"
        matTooltipClass="varden-tooltip"
        matTooltipPosition="above"
      >
        Toppval
      </div>
    }

  </div>
}

